import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { MultipleLineItemExportButton } from '@pay-bill/components';
import { ReverseInvoiceListItemFragmentType } from '@pay-bill/graphql';

export const ReverseInvoiceBulkActionFooter = ({
  reverseInvoices,
  onFinish,
}: {
  reverseInvoices: ReverseInvoiceListItemFragmentType[];
  onFinish: () => void;
}) => (
  <div className="bulk-action-content">
    <footer className="bulk-action-footer">
      <div className="footer-element invoices-count">
        {reverseInvoices.length}{' '}
        {reverseInvoices.length > 1 ? 'reverse invoices' : 'reverse invoice'}{' '}
        selected.
      </div>
      <div className="footer-element">
        <MultipleLineItemExportButton
          entityType="reverse_invoice"
          onFinish={onFinish}
          entityIds={reverseInvoices.map((entity) => entity.id)}
        />
      </div>
    </footer>
    <style jsx>{`
      .bulk-action-content {
        margin-top: 32px;
      }

      .footer-element {
        font-size: 16px;
        margin-right: 10px;
      }

      .invoices-count {
        padding-top: 4px;
      }

      .bulk-action-footer {
        border-top: 2px solid ${Colors.steel};
        padding: 16px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background-color: ${Colors.white};
        position: fixed;
        bottom: 0;
        left: 80px;
        width: calc(100% - 80px);
      }
    `}</style>
  </div>
);
